import { Slot } from '@radix-ui/react-slot';
import { cva } from 'class-variance-authority';
import { clsx } from 'clsx';
import { type ComponentPropsWithoutRef } from 'react';

import { useDialog } from '@repo/ui/Dialog/DialogRoot';

import s from './DialogHeader.module.css';

export type DialogHeaderProps = ComponentPropsWithoutRef<'header'> & {
  as?: 'div' | 'header';
  asChild?: boolean;
  className?: string;
};

export const dialogHeaderVariants = cva(s.header, {
  variants: {
    variant: {
      compact: s.compactVariant,
      standard: s.standardVariant,
    },
  },
});

export const DialogHeader = (props: DialogHeaderProps) => {
  const { as = 'header', asChild, children, className, ...attrs } = props;
  const { variant } = useDialog();

  const Component = asChild ? Slot : as;

  return (
    <Component
      className={clsx(dialogHeaderVariants({ variant }), className)}
      {...attrs}
    >
      {children}
    </Component>
  );
};
